import * as React from 'react'
import Typography from '@mui/material/Typography'

const PageNotFound = () => {
  return (
    <Typography component='h2' variant='h6' color='primary'>
      404 not found
    </Typography>
  )
}

export default PageNotFound
